import React, { useState, useEffect } from "react";
import { Menu, X, Crown } from "lucide-react";

const NAV = [
  { label: "Vision", href: "#vision" },
  { label: "Rituel", href: "#rituel" },
  { label: "Ateliers", href: "#ateliers" },
  { label: "Incubateur", href: "#incubateur" },
  { label: "Les Espaces", href: "#espaces" },
  { label: "Galerie", href: "#galerie" },
  { label: "App", href: "#application" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAF7F2]/95 backdrop-blur-md border-b border-[#4A192C]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 py-5 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => scrollTo(e, "#top")}
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <span className="w-10 h-10 border border-[#4A192C] flex items-center justify-center">
            <Crown className="w-5 h-5 text-[#4A192C] group-hover:text-[#C5A059] transition-colors" />
          </span>
          <div className="flex flex-col leading-tight">
            <span className="font-serif-display text-lg text-[#4A192C]">
              Le Sanctuaire des Mères
            </span>
            <span className="text-[0.62rem] tracking-[0.32em] uppercase text-[#6B585F]">
              Association Les Mamans Reines
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={(e) => scrollTo(e, n.href)}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-[0.72rem] tracking-[0.24em] uppercase text-[#2C1E23] hover:text-[#4A192C] sdm-link-underline"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href="#don"
            onClick={(e) => scrollTo(e, "#don")}
            data-testid="header-donate-button"
            className="sdm-btn-gold"
          >
            Faire un don
          </a>
        </div>

        <button
          onClick={() => setOpen(true)}
          data-testid="menu-open-button"
          className="lg:hidden w-10 h-10 border border-[#4A192C] flex items-center justify-center text-[#4A192C]"
          aria-label="Ouvrir le menu"
        >
          <Menu className="w-5 h-5" />
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="fixed inset-0 z-50 bg-[#FAF7F2] flex flex-col px-6 py-5"
        >
          <div className="flex items-center justify-between">
            <span className="font-serif-display text-xl text-[#4A192C]">
              Le Sanctuaire
            </span>
            <button
              onClick={() => setOpen(false)}
              data-testid="menu-close-button"
              className="w-10 h-10 border border-[#4A192C] flex items-center justify-center"
              aria-label="Fermer le menu"
            >
              <X className="w-5 h-5 text-[#4A192C]" />
            </button>
          </div>
          <div className="flex flex-col gap-6 mt-16">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={(e) => scrollTo(e, n.href)}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className="font-serif-display text-3xl text-[#4A192C]"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#don"
              onClick={(e) => scrollTo(e, "#don")}
              data-testid="mobile-header-donate-button"
              className="sdm-btn-gold mt-8 justify-center"
            >
              Faire un don
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
